import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivationStepsService } from 'src/app/shared/services/activation-steps.service';
import { UpdateActivationStatusService } from 'src/app/shared/services/update-activation-status.service';

@Component({
  selector: 'app-business-bank-account',
  templateUrl: './business-bank-account.component.html',
  styleUrls: ['./business-bank-account.component.scss'],
})
export class BusinessBankAccountComponent implements OnInit {
  constructor(
    public activationStepsService: ActivationStepsService,
    public UpdateActivationStatus: UpdateActivationStatusService,
    public dialog: MatDialog
  ) {}

  async ngOnInit() {}
}
